// Routes that must never hard-redirect to /login. /widget is an embeddable
// iframe route that carries its own JWT via the ?token= URL param — a
// redirect to the full-page login breaks the HIS embed. Single source of
// truth for AuthContext and api.ts.
export const PUBLIC_PATHS = ['/login', '/complete-registration', '/widget'];

export const isPublicPath = (): boolean =>
  PUBLIC_PATHS.some(p => window.location.pathname.startsWith(p));
